import React, { useState } from 'react'
import Select from 'react-select'
import { PhoneInput } from 'react-international-phone'
import { ajaxGet, ajaxPost } from '../../ajax'

export default function AddPlayer({gameId, onError, onGameUpdated}) {
  const [newPlayer, setNewPlayer] = useState()
  const [selectedPlayer, setSelectedPlayer] = useState()

  const loadPlayers = async (input) => {
    if (!input || input.length < 3) return Promise.resolve({options: []})

    const params = { q: input, reservation_id: gameId }
    const response = await ajaxGet('/admins/clients.json?' + new URLSearchParams(params))
    const json = await response.json()
    return {
      options: json.users.map(user => ({value: user.id, label: user.text}))
    }
  }

  const playerAdded = (data) => {
    setNewPlayer(null)
    setSelectedPlayer(null)
    onGameUpdated(data)
  }

  const onAdd = async (e) => {
    if (!selectedPlayer && !newPlayer) return
    e.target.blur()

    const data = newPlayer || { id: selectedPlayer.value }
    const response = await ajaxPost(`/admins/games/${gameId}/player_reservations.json`, { player: data })
    const json = await response.json()
    if (json.alert) onError(json.alert)
    else playerAdded(json)
  }

  const onSelected = (player) => {
    setSelectedPlayer(player)

    if (!player) return setNewPlayer(null)
    if (player.value === player.label) return setNewPlayer({first_name: player.value})

    setNewPlayer(null)
    setSelectedPlayer(player)
  }

  const renderSelect = () => {
    return <Select.AsyncCreatable
      isValidNewOption={data => data.label && (data.label.length >= 3)}
      loadOptions={loadPlayers}
      name='firstName'
      className='player-selector'
      onChange={onSelected}
      placeholder='Select a client'
      autoBlur
      filterOption={() => true}
      promptTextCreator={text => text.length >= 3 ? `+ New Client "${text}"` : ''}
      value={selectedPlayer}
      searchPromptText='Please enter 3 or more characters'
      onCloseResetsInput={false}
      onBlurResetsInput={false}
    />
  }

  const onUpdateNewPlayer = (params) => {
    setNewPlayer({...newPlayer, ...params})
  }

  const renderPlayerForm = () => {
    return <div className='player-selector'>
      <div className='player-selector__input'>
        <input className='form-control' placeholder='First Name'
          value={newPlayer.first_name}
          onChange={e => onUpdateNewPlayer({first_name: e.target.value})}
        />
      </div>
      <div className='player-selector__input'>
        <input className='form-control' placeholder='Last Name'
          onChange={e => onUpdateNewPlayer({last_name: e.target.value})}
        />
      </div>
      <div className='player-selector__input flag-hidden'>
        <PhoneInput
          placeholder='Phone Number'
          inputClassName='form-control'
          value={newPlayer.phone}
          onChange={(phone, country) => onUpdateNewPlayer({country_code: country, phone: phone})}
        />
      </div>
      <div className='player-selector__input'>
        <input className='form-control' type='email' placeholder='Email'
          value={newPlayer.email}
          onChange={e => onUpdateNewPlayer({email: e.target.value})} 
        />
      </div>
    </div>
  }

  return <div className='add-player-container'>
    Add new Player
    <div className='row'>
      <div className='col-xs-10'>
        {newPlayer ? renderPlayerForm() : renderSelect()}
      </div>
      <div className='col-xs-2'>
        <button className='btn btn-success' onClick={onAdd}>Add</button>
      </div>
    </div>
  </div>
}
